import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import {
    DropdownType,
    getDigitalNumeberData,
    ItemSymbolType,
} from '@editor/src/js/constants/toolbar-data';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_DROPDOWN } from '@editor/src/img/pageIndex';
import { TDWActionType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import DIGIT_NUMBER_ICON from '@src/img/first-screen/digitNumber.svg';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

export const config = {
    id: ActionType.DIGITNUMBER,
    tipMsg: i18n.t('数字编号'),
    icon: DIGIT_NUMBER_ICON,
    value: ItemSymbolType.ITEMSYMBOL_NONE,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.GRID,
        checkSelectedValue: true,
        columns: 4,
        // 工具栏中项目符号列表需要根据当前选中项目符号动态显示
        getData: () => {
            const menuManager = (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices)
                .editableServiceLayer?.menuManager;
            const values = menuManager?.toolbarMenu().values ?? {};
            const startNumber = values[ActionType.BULLET_START_NUMBER] || 1;
            const color = values[ActionType.BULLET_COLOR]?.rgb || undefined;
            // @ts-ignore 目标文件是 js 文件，参数类型推断错误且无法标注类型
            return getDigitalNumeberData(color, startNumber);
        },
    },
    twdConfig: {
        action: TDWActionType.NUMBER_LIBRARY,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
        hasArrow: true,
    },
];
